import { BlockManager } from '../utils';

export function ancestorOf(type: string, targetType: string): number {
    const level = -1;
    const paths = BlockManager.getAutoCompletePath(type, targetType);

    if (paths) {
        return paths.length + 1;
    }
    return level;
}
